import React, { useEffect, useState, useRef } from 'react';
import QuizActionAPI, {
    IUpdateQuizPayload,
    IFetchQuizPayload,
} from '../../../../redux/quiz/quiz.actions';
import { Course } from '../../../../@types/course.interface';
import { User } from '../../../../@types/user.interface';
import { connect } from 'react-redux';
import { fetchApi } from '../../../../redux/fetch/fetch.actions';
import { Dispatch } from 'redux';
import { GlobalState } from '../../../../redux/root-reducer';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { Quiz } from '../../../../@types/quiz.interfaces';
import Loading from '../../../../components/loading/loading.component';
import QuizForm from '../../../../components/quiz-form/quiz-form.component';
import { validateQuizForm } from '../../../../utils/validation';

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    user: User | null;
    courses: Course[];
    quiz: Quiz | null;
    fetchCourses: () => void;
    fetchQuiz: (id: IFetchQuizPayload['data']['id']) => void;
    updateQuiz: (data: IUpdateQuizPayload['data']) => void;
    clearQuizzes: () => void;
    clearQuiz: () => void;
}
function UpdateQuizContainer({
    isFetching,
    errors,
    user,
    courses,
    quiz,
    fetchQuiz,
    fetchCourses,
    updateQuiz,
    clearQuizzes,
    clearQuiz,
}: IProps) {
    const match = useRouteMatch<{ id: string }>();
    const history = useHistory();
    const id = parseInt(match.params.id);
    const fetching = useRef(false);

    const [tempQuiz, setTempQuiz] = useState({
        quiz_id: 0,
        user_id: 0,
        course_id: 0,
        quiz_duration: 0,
    });

    useEffect(() => {
        if (isFetching || errors) return;
        if (courses.length === 0) fetchCourses();
        if (user)
            setTempQuiz((prevState) => ({
                ...prevState,
                user_id: user.user_id,
            }));
        if (quiz === null) fetchQuiz(id);
        if (quiz && quiz?.quiz_id !== undefined && quiz.courses !== undefined)
            setTempQuiz((prevState) => ({
                ...prevState,
                quiz_id: quiz.quiz_id,
                course_id: quiz.courses?.course_id,
                quiz_duration: quiz.quiz_duration,
            }));
    }, [
        isFetching,
        errors,
        user,
        fetchCourses,
        courses.length,
        fetchQuiz,
        id,
        quiz,
        tempQuiz.user_id,
    ]);

    useEffect(() => {
        if (isFetching === false && fetching.current === true)
            history.push('/quiz/view');
        return () => {
            clearQuizzes();
            clearQuiz();
        };
    }, [isFetching, history, clearQuizzes, clearQuiz]);

    const handleChange = (evt: any, name: string) => {
        let val = evt.target.value;
        val = parseInt(val);
        if (val < 0) {
            val = 0;
            evt.target.value = 0;
        }
        setTempQuiz((prevState) => ({
            ...prevState,
            [name]: val,
        }));
    };

    const [error, setError] = useState('');
    const handleClick = async (evt: any) => {
        evt.preventDefault();
        setError(validateQuizForm(tempQuiz, errors));
        if (validateQuizForm(tempQuiz, errors) === '') {
            updateQuiz(tempQuiz);
            fetching.current = true;
        }
    };

    return (
        <div className="container">
            {isFetching ? (
                <Loading className="fixed" />
            ) : (
                <div className="container__content">
                    <QuizForm
                        quiz={tempQuiz}
                        courses={courses}
                        handleClick={handleClick}
                        handleChange={handleChange}
                        error={error}
                        update
                        id={id}
                    />
                </div>
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    user: {
        self: { data },
    },
    courses: { courses },
    quiz: { quiz },
}: GlobalState) => ({
    isFetching: isFetching.UPDATE_QUIZ,
    errors: errors.UPDATE_QUIZ,
    user: data,
    courses,
    quiz,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchCourses: () => dispatch(fetchApi({ name: 'COURSE' })),
    fetchQuiz: (id: IFetchQuizPayload['data']['id']) =>
        dispatch(fetchApi({ name: 'QUIZ', data: { id } })),
    updateQuiz: (data: IUpdateQuizPayload['data']) =>
        dispatch(fetchApi({ name: 'UPDATE_QUIZ', data })),
    clearQuizzes: () => dispatch(QuizActionAPI.clearQuizzes()),
    clearQuiz: () => dispatch(QuizActionAPI.clearQuiz()),
});

const UpdateQuizPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdateQuizContainer);

export default UpdateQuizPage;
